import { Key } from 'react';

export interface DataItem {
  [key: string]: string | number | JSX.Element | Object;
}
export interface ColumnItem {
  key: string;
  title: string;
  dataType: CustomCellEnum;
  isEditable: boolean;
  optionConfig?: OptionConfig;
  isHide?: boolean;
  props?: CustomCellProps;
  customCellValue?: (value: DataItem) => string;
}

export interface OptionConfig {
  options: Array<DataItem>;
  displayKey: string;
}

export interface CustomCellProps {
  type?: string;
  min?: number;
  max?: number;
}

export interface CustomCellData {
  source: DataItem;
  value: string | number;
  key: string;
}

export enum CustomCellEnum {
  Input = 'input',
  Option = 'option',
  Element = 'element'
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export type Columns = Array<ColumnItem>;
export type Data = Array<DataItem>;
export type SortingState = Record<string, SortDirection>;
export type ControlPanelActions = {
  onAdd?: () => void;
  onDelete?: (selectedRow: Array<Key>) => void;
  onSearch?: (searchParams: string) => void;
  onVisibleColumns?: (value: { name: string; isHide: boolean }) => void;
};
